<template>
    <v-dialog
        class="change-password-dialog"
        :open="show"
        :title="$t('修改密码')"
        @input="handleToggleDialogVisiable"
    >
        <div class="dialog-content-step">
            <v-steps
                :titles="stepTitles"
                :index="stepIndex"
            />
        </div>
        <div class="dialog-content-main">
            <template v-if="stepIndex === 1">
                <!-- 已经绑定了手机 -->
                <v-form
                    ref="form"
                    class="form"
                    @submit.prevent="handleValidateMsg"
                    kind="desc"
                >
                    <div class="text-description">
                        <i18n-t path="请使用 {username} 已绑定的手机号{mobile}接收验证码" tag="span">
                            <span slot="username">{{ username }}</span>
                            <span slot="mobile" class="text-primary">{{ encryptTel(mobile) }}</span>
                        </i18n-t>
                    </div>
                    <v-form-item
                        style="margin-top:40px;"
                        name="sms_code"
                        error-placement="top-right"
                        :rules="formRules.sms_code"
                        :label="$t('验证码')"
                    >
                        <div class="captch-wrap">
                            <v-input
                                v-model="form.sms_code"
                                kind="default"
                                style="width:190px;"
                                :placeholder="$t('请输入验证码')"
                            />
                            <v-button
                                class="captch-btn"
                                :disabled="isCountdown"
                                :loading="sendCaptchaLoading"
                                @click="sendCaptcha"
                            >
                                {{ isCountdown ? $t('{n}s', { n: countdown }) : $t('获取验证码') }}
                            </v-button>
                        </div>
                    </v-form-item>
                    <v-form-item class="btn-row">
                        <v-button
                            type="submit"
                            class="bind-btn"
                            kind="primary"
                            size="large"
                            :loading="checkoutMsgLoading"
                        >
                            {{ $t('下一步') }}
                        </v-button>
                    </v-form-item>
                    <div class="tip-text">
                        {{ $t('如果一直未接收到验证码，请联系管理员帮您重置密码') }}
                    </div>
                </v-form>
            </template>
            <v-form
                v-show="stepIndex === 2"
                ref="form"
                class="password-form"
                kind="desc"
                @submit.prevent="handleChangePassword"
            >
                <div class="description">
                    <p>{{ $t('密码长度需8-16位，且包含以下情况的3种：') }}</p>
                    <p>{{ $t('大写字母、小写字母、数字、符号、*、%等') }}</p>
                </div>
                <v-form-item
                    name="password"
                    error-placement="top-right"
                    :rules="passwordRulesForm.password"
                    :label="$t('新密码')"
                >
                    <v-input
                        v-model="passwordForm.password"
                        password
                        style="width:288px;"
                    />
                </v-form-item>
                <v-form-item
                    name="confirmPassword"
                    error-placement="top-right"
                    :rules="passwordRulesForm.confirmPassword"
                    :label="$t('重复密码')"
                >
                    <v-input
                        v-model="passwordForm.confirmPassword"
                        password
                        style="width:288px;"
                    />
                </v-form-item>
                <v-form-item class="btn-row">
                    <v-button
                        type="submit"
                        class="bind-btn"
                        kind="primary"
                        size="large"
                        :loading="bindLoading"
                    >
                        {{ $t('保存') }}
                    </v-button>
                    <v-button
                        type="submit"
                        class="bind-btn-secend"
                        size="large"
                        @click="stepIndex = 1"
                    >
                        {{ $t('取消') }}
                    </v-button>
                </v-form-item>
                <div class="tip-text">
                    {{ $t('修改密码后，您需要重新登录企点账号') }}
                </div>
            </v-form>
        </div>
    </v-dialog>
</template>

<script>
// import InternationalTelInput from '@/components/international-tel-input';
import { encryptTel } from '@/components/international-tel-input/utils';
import md5 from '@/utils/md5.js';
import Gateway from '@/utils/Gateway';
import { PASSWORD_VALID_REGEXP } from '@/config/pswVaild';

const SEND_MSG_URL = '/v1/basic.account.account_web.AccountWeb/SendLoginMSG'; // 发送短信
const CHECK_MSG_URL = '/v1/basic.account.account_web.AccountWeb/CheckVerifyCode'; // 短信验证
const CHANGE_PASSWORD_URL = '/v1/basic.account.account_web.Account/UpdatePsw'; // 修改密码
const ACTIVE_ACCOUNT_URL = '/v1/basic.account.account_web.AccountWeb/ActiveAccount'; // 账号激活
const DEFAULT_FORM = {
    mobile: '',
    sms_code: '',
    is_sync_login: false,
};
const COUNT_DOWN_INIT = 60;
export default {
    components: {
        // InternationalTelInput
    },
    props: {
        mode: {
            typeof: Boolean,
            default: false,
        },
        show: {
            typeof: Boolean,
            default: true,
        },
        username: {
            typeof: String,
            default: '',
        },
        mobile: {
            typeof: String,
            default: '',
        },
        aid: {
            typeof: String,
            default: '',
        },
    },
    data() {
        // const vm = this;
        return {
            // hasTel: true,
            passwordForm: {
                password: '',
                confirmPassword: '',
            },
            stepTitles: [this.$t('帐号验证'), this.$t('修改密码')],
            stepIndex: 1,
            form: {
                ...DEFAULT_FORM,
            },
            bindLoading: false,
            checkoutMsgLoading: false,
            countdown: COUNT_DOWN_INIT,
            countdownTimer: null,
            sendCaptchaLoading: false,
            passwordRulesForm: {
                password: [
                    { required: true, message: this.$t('密码不能为空'), trim: true },
                    { minLength: 8, message: this.$t('密码最小长度为8位'), trim: true },
                    { maxLength: 16, message: this.$t('密码最大长度为16位'), trim: true },
                    {
                        validate(value) {
                            return PASSWORD_VALID_REGEXP.test(value);
                        },
                        message: this.$t('不符合安全强度要求'),
                    },
                ],
                confirmPassword: [{ equalTo: 'password', message: this.$t('两次输入的密码不一致') }],
            },
            formRules: {
                sms_code: [
                    {
                        required: true,
                        message: this.$t('验证码不能为空'),
                        trigger: 'blur',
                        trim: false,
                    },
                    {
                        validate(value) {
                            return /^\d{6}$/.test(value);
                        },
                        message: this.$t('验证码格式错误'),
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    computed: {
        isCountdown() {
            return this.countdown < COUNT_DOWN_INIT;
        },
    },
    methods: {
        encryptTel,
        hasInputTel() {
            const internationalInput = this.$refs.internationalTelInput;
            return internationalInput && internationalInput.getTel().length > 0;
        },
        handleToggleDialogVisiable(visiable) {
            this.$emit('update:show', visiable);
        },

        handleValidateMsg() {
            this.checkoutMsgLoading = true;
            const params = {
                mobile: this.mobile,
                sms_code: this.form.sms_code,
            };
            Gateway.post(CHECK_MSG_URL, params)
                .then(() => {
                    this.stepIndex = 2;
                    this.checkoutMsgLoading = false;
                    this.clearCountdownTimer();
                    this.$message.success(this.$t('手机验证成功'));
                })
                .catch((err) => {
                    this.checkoutMsgLoading = false;
                    this.$message.error(err || this.$t('网络故障，请稍后再试'));
                });
        },
        handleChangePassword() {
            this.bindLoading = true;
            const params = this.mode  ? {
                phone_number: this.mobile,
                sms_code: this.form.sms_code,
                pwd: md5(this.passwordForm.password),
            } : {
                mobile: this.mobile,
                sms_code: this.form.sms_code,
                password: md5(this.passwordForm.password),
                aid: this.aid,
                pwd_len: this.passwordForm.password.length,
            };
            const POST_URL = this.mode ? ACTIVE_ACCOUNT_URL : CHANGE_PASSWORD_URL;
            Gateway.post(POST_URL, params)
                .then(() => {
                    this.$message.success(this.mode ? this.$t('激活成功') : this.$t('密码修改成功'));
                    this.$emit('on-success');
                    this.$emit('update:show', false);
                    this.bindLoading = false;
                })
                .catch((err) => {
                    this.$message.error(err || this.$t('网络故障，请稍后再试'));
                    this.bindLoading = false;
                    throw err;
                });
        },
        startCountdown() {
            /* eslint-disable no-plusplus */
            this.countdown--;
            this.countdownTimer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= -1) {
                    this.clearCountdownTimer();
                    this.countdown = COUNT_DOWN_INIT;
                }
            }, 1000);
            this.$once('hook:beforeDestroy', this.clearCountdownTimer);
        },
        clearCountdownTimer() {
            clearInterval(this.countdownTimer);
            this.countdown = COUNT_DOWN_INIT;
        },
        sendCaptcha() {
            // 如果手机号码不合法，则不能获取验证码
            // if (!this.$refs.internationalTelInput.isValid()) {
            //     return;
            // }
            this.sendCaptchaLoading = true;
            const form = {
                mobile: this.mobile,
                type: 1,
            };
            Gateway.post(SEND_MSG_URL, form)
                .then(() => {
                    // data.code = 1003 [1003]验证码发送频繁，请稍后再试
                    this.startCountdown();
                    this.sendCaptchaLoading = false;
                })
                .catch((err) => {
                    this.sendCaptchaLoading = false;
                    this.$message.error(err || this.$t('网络故障，请稍后再试'));
                    throw err;
                });
        },
        handleSubmit() {
            const formData = this.form;
            console.log(formData);
        },
        resetForm() {
            this.form = {
                ...DEFAULT_FORM,
            };
            this.clearCountdownTimer();
            this.countdown = COUNT_DOWN_INIT;
            this.stepIndex = 1;
        },
    },
};
</script>

<style lang="less">
.change-password-dialog {
    .v-dialog__content {
        padding: 40px 0 20px;
        width: 500px;
    }
    .captch-wrap {
        position: relative;
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        .captch-btn {
            margin-left: 20px;
            position: relative;
            right: 0;
            top: -3px;
        }
    }
    .btn-row {
        .v-description-item--text-content {
            width: 0;
        }
        .bind-btn-secend {
            margin-left: 16px;
        }
    }
    .dialog-content-step {
        padding: 0 40px;
    }
    .dialog-content-main {
        padding: 0 20px 0;
        .form {
            .text-description {
                font-size: 14px;
                color: #1e2330;
                line-height: 20px;
                .text-primary {
                    color: #0067ed;
                }
                margin-top: 4px;
            }
            .form-label {
                text-align: left;
                margin-right: 15px;
            }
            .v-form-item__desc {
                font-size: 12px;
                margin-left: 40px;
            }
            .v-input--simple {
                height: 32px;
            }
            .tip-text {
                margin-top: -22px;
                font-size: 12px;
                line-height: 17px;
                color: #a8abb3;
            }
            .captch-btn {
                min-width: 106px;
            }
            .btn-row {
                .v-form-item__input {
                    width: 100%;
                    .bind-btn {
                        margin-top: 50px;
                        width: 150px;
                        float: none;
                    }
                }
            }
        }
        .password-form {
            .form-label {
                display: inline-block;
                text-align: left;
                width: 56px;
                margin-right: 15px;
            }
            .description {
                margin: 20px 0;
            }
            .v-form-item__desc {
                font-size: 12px;
                text-align: left;
                margin-left: 70px;
            }
            .tip-text {
                margin-top: -22px;
                font-size: 12px;
                line-height: 17px;
                color: #a8abb3;
            }
            .captch-btn {
                width: 102px;
                right: -112px;
                position: absolute;
            }
            .btn-row {
                margin-top: 50px;
                .v-form-item__input {
                    width: 100%;
                    height: 32px;
                    .bind-btn {
                        width: 150px;
                        float: none;
                        &:not(:first-child) {
                            margin-left: 20px;
                        }
                    }
                }
            }
        }
    }
}
</style>
